<div class="minclt-dialog">
	<div class="px-3"
		*ngIf="!!dynamicDialogConfig.data?.tableroInformativo && dynamicDialogConfig.data.tableroInformativo.length > 0 ">
		<app-tablero-informativo [dataIndicators]="dynamicDialogConfig.data.tableroInformativo" />
	</div>

	<div class="minclt-border py-4">
		<app-form-print-two [questions]="questions" [textButtonSubmit]="dynamicDialogConfig.data.textForm"
			[hideAlertToSubmit]="dynamicDialogConfig.data.hideAlert" [showButtonsSubmit]="false"
			(validFormPrint)="onValidFormChange('a', $event)" (cancelQuestions)="dynamicDialogRef.close()" #formPrintTwo/>
	</div>

	<div *ngIf="showButtonsForm" class="flex gap-2 px-3 py-3" [ngClass]="{
                ' justify-content-between': showModalBtnEdit, 
                ' justify-content-end': !showModalBtnEdit, 
            }">
		<ng-container *ngIf="showModalBtnEdit">
			<p-button label="Editar" styleClass="amarillo" (click)="onClickEdit()" />
		</ng-container>
		<div *ngIf="showModalButtons"  class="flex gap-2">
			<p-button label="Cancelar" styleClass="morado" (click)="onCancel()" />
			<p-button [label]="dynamicDialogConfig.data.textForm" (click)="onSubmit()" [styleClass]="colorBtn" [disabled]="!btnIsDisabled" />
		</div>
	</div>
</div>